interface Array<T> {
    safeContains(o: T): boolean;
}

Array.prototype.safeContains = function(o) {
    if (this) {
        return this.length > 0 && this.indexOf(o) > -1;
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/app/prototypes/array-prototypes.ts